define('views/parts/form/choices',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/list',
    'views/parts/form/choices/choice-item',
    // templates
    'text!templates/parts/form/choices.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VList,
    VChoiceItem,
    // templates
    TChoices
) {

    var ITEM_OPTIONS = ['type', 'name', 'attribute', 'styleButton', 'namespace', 'imageLabel', 'addItemClass'];

    /**
     * Creates an input checkbox (default) or radio button with an inline label
     * and provides two-way binding via Epoxy.
     *
     * @param  {Boolean} radio default to false.
     * @param  {string} attribute of the model.
     * @param  {string} name of the input element (default to the attribute).
     * @param  {Array} choices the array of object defining "label" and "value".
     */
    var VChoices = VList.extend({
        item: VChoiceItem,

        template: TChoices,

        events: {
            "change input": "onValueChange",
        },

        regions: {
            choices: ".choice",
            list: '.choices-list'
        },

        initialize: function(opt) {
            var options = this.options = _.extend({
                type: opt.radio ? "radio" : "checkbox",
                name: opt.name || opt.attribute,
                attribute: "value",
                needsTranslatedLabel: true,
                styleButton: false
            }, opt);

            var model = this.model;
            if (!model) {
                model = this.model = new Backbone.Model();
                model.set(options.attribute, null);
            }

            if (!options.choices) {
                options.choices = [
                    { label: options.label, value: model.get(options.attribute) }
                ];
            }

            this.collection = new Backbone.Collection(options.choices);

        },
        render: function() {
            var html = Mustache.render(this.template,
                Mustache.getContext(this.options, this.options.namespace));
            this.$el.empty().append(html);

            this.generateZones();

            VChoices.__super__.render.call(this);

            this.applyBindings();

            return this;
        },

        getItemOptions: function(options) {
            return _.extend(options, {
                model: this.model,
                choice: options.model.toJSON(),
            }, _.pick(this.options, ITEM_OPTIONS));
        },

        toggleDisabled: function(val) {
            this.zone.$choices.toggleDisabled(val);
        },

        getValue: function() {
            return this.model.get(this.options.attribute);
        },

        setValue: function(value, options) {
            this.model.set(this.options.attribute, value, options);
        },

        selectFirstOption: function() {
            var first = this.collection.first();
            this.setValue(first.get('value'));
        },

        onValueChange: function(e) {
            var options = this.options,
                params = [this.model, this.getValue()];
            _.callback(options.context, options.onChange, params);

            this.trigger.apply(this, ["change"].concat(params));
        },

    });

    return VChoices;
});

